// @flow
import * as React from "react";
import SpeedReadingGlimpse from "./src/SpeedReadingGlimpse.js";

export default function App(props: any) {
  return <SpeedReadingGlimpse {...props} />;
}
